import {
  any,
  bool,
  func,
  object,
  oneOf,
  string,
  shape,
} from 'prop-types';
import { TextField } from '@material-ui/core';

import {
  InputClabe,
  InputCreditCard,
  InputCreditCardExpireTime,
  InputCurrency,
  InputMxPhone,
  InputPercentage,
} from './inputs';

function NumberControl(props) {
  const {
    disabled,
    events = {},
    name,
    onBlur,
    onChange,
    settings: { format },
    size,
  } = props;

  const inputComponent = {
    clabe: InputClabe,
    credit_card: InputCreditCard,
    credit_card_expire_time: InputCreditCardExpireTime,
    currency: InputCurrency,
    mx_phone: InputMxPhone,
    percentage: InputPercentage,
  }[format];

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && events.onSubmit) {
      e.preventDefault();
      events.onSubmit();
    }
  };

  return (
    <TextField
      disabled={disabled}
      error={props.error}
      fullWidth={true}
      helperText={props.helperText}
      InputProps={{
        inputComponent,
        inputProps: {
          style: {
            color: '#282828',
            fontWeight: '700',
            fontSize: 16,
          },
        },
      }}
      label={props.label}
      name={name}
      onBlur={onBlur}
      onChange={({ target }) => {
        let { value } = target;
        if (!inputComponent) {
          value = parseFloat(value.replace(/[^\d.-]/g, ''));
        }

        onChange({
          target: {
            name,
            value,
          },
        });

        if (events.onChange) {
          events.onChange({
            name,
            value: value || '',
          });
        }
      }}
      onKeyDown={handleKeyDown}
      size={size}
      type={inputComponent ? 'text' : 'number'}
      variant={props?.variant ?? 'outlined'}
      value={props.value}
      style={{
        backgroundColor: 'rgba(245, 245, 245, 0.01)',
      }}
    />
  );
}

NumberControl.defaultProps = {
  disabled: false,
  error: false,
  onBlur: () => { },
  onChange: () => { },
  settings: {},
};

NumberControl.propTypes = {
  disabled: bool,
  error: bool,
  events: object,
  helperText: string,
  label: string,
  name: string,
  onBlur: func,
  onChange: func,
  settings: shape({
    format: oneOf([
      'clabe',
      'credit_card',
      'credit_card_expire_time',
      'currency',
      'mx_phone',
      'percentage',
    ]),
  }),
  size: oneOf([
    'small',
    'medium',
  ]),
  value: any,
  variant: oneOf([
    'filled',
    'outlined',
  ]),
};

export default NumberControl;
